import { useCallback, useState } from 'react';

function read(key: string, fallback: boolean): boolean {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : raw === '1';
  } catch {
    return fallback; // private mode / blocked storage
  }
}

/**
 * A per-browser on/off preference. Storage is a convenience: when it is
 * blocked the toggle still works for this session.
 */
export function useStoredToggle(key: string, fallback: boolean): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState(() => read(key, fallback));
  const update = useCallback(
    (next: boolean) => {
      setValue(next);
      try {
        window.localStorage.setItem(key, next ? '1' : '0');
      } catch {
        // not persisted; the in-memory value still applies
      }
    },
    [key],
  );
  return [value, update];
}
